import { Injectable } from '@angular/core';

export interface IServicePost {
  title: string,
  paragraph1: string,
  paragraph2?: string,
  paragraph3?: string,
  paragraph4?: string,
  quote1?: string,
  quote2?: string,
  quote3?: string,
  graphicUrl1?: string,
  graphicUrl2?: string
}

export interface IServiceList {
  image: string,
  title: string,
  message: string,
  link: string,
  hideBlogPost?: boolean
};
@Injectable({
  providedIn: 'root'
})

export class ServicesPageService {
  public serviceList: IServiceList[] = [
    {
      image: "assets/img/case_studies_1.jpg",
      title: "Website Visitor Analytics",
      message: "With site tracking, we're able to gather data on site visitors and present data in a visual manner.",
      link: "data-analytics"
    },
    {
      image: "assets/img/case_studies_2.jpg",
      title: "Website Development",
      message: "Wether you're looking for a full refresh or want to create your site from the ground up, we can help!",
      link: "web-development"
    },
    {
      image: "assets/img/case_studies_4.jpg",
      title: "A/B Testing",
      message: "By using A/B Testing and site trackers we can see which ads work and lead to the most conversions.",
      link: "traffic-sales",
    },
    {
      image: "assets/img/case_studies_3.jpg",
      title: "Increasing your SEO Ranking",
      message: "One of the often overlooked metric to businesses is their search authority, higher ranking means the closer the website is to be the 1st search result.",
      link: "seo"
    },
    // {
    //   image: "assets/img/case_studies_5.jpg",
    //   title: "Email Marketing",
    //   message: "Studies have shown that emailing is an effective way to get your customer's to visit again",
    //   link: "email-marketing"
    // },
    {
      image: "assets/img/case_studies_6.jpg",
      title: "Social Media and Email Marketing",
      message: "As of 2021, 72% of Adults use at least one social media, this is a great place for new customers to discover you.",
      link: "social-marketing"
    },
    // {
    //   image: "assets/img/case_studies_7.jpg",
    //   title: "Marketing Strategies",
    //   message: "No one strategy works for all companies, depending on your target audience, we may focus on social media more then email.",
    //   link: "marketing-strategies"
    // },
    // {
    //   image: "assets/img/case_studies_8.jpg",
    //   title: "Content Marketing",
    //   message: "Keeping customers engaged with your brand is key to make a lasting impression with customers.",
    //   link: "content-marketing",
    //   hideBlogPost: true,
    // }
  ]

  getServiceList(): IServiceList[] {
    return JSON.parse(JSON.stringify(this.serviceList));
  }
  constructor() { }
}
